import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { useLocalizedTestimonials } from '../../hooks/useLocalizedCMS';

export default function TestimonialsSection() {
  const { t } = useLanguage();
  const { testimonials } = useLocalizedTestimonials();
  return (
    <section data-testid="testimonials-section" className="py-16 lg:py-24" style={{ backgroundColor: '#F9F8F4' }}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <span className="text-xs font-semibold uppercase tracking-[0.2em]" style={{ color: '#D97706' }}>{t.testimonials.badge}</span>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl mt-2" style={{ color: '#0A3F22' }}>{t.testimonials.title}</h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((item, i) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 25 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.15 }}
              className="bg-white p-6 rounded-xl shadow-sm border card-hover"
              style={{ borderColor: '#E5E7EB' }}
            >
              <div className="flex gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((s) => <Star key={s} size={14} fill="#D97706" style={{ color: '#D97706' }} />)}
              </div>
              <p className="text-sm leading-relaxed mb-4 italic" style={{ color: '#4A554A' }}>&quot;{item.quote}&quot;</p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full flex items-center justify-center font-heading font-bold text-white text-sm"
                  style={{ backgroundColor: '#0A3F22' }}>
                  {item.name.charAt(0)}
                </div>
                <div>
                  <div className="font-heading font-semibold text-sm" style={{ color: '#1A1C1A' }}>{item.name}</div>
                  <div className="text-xs" style={{ color: '#4A554A' }}>{item.location} · {item.role}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
